var $ = global.jQuery = global.$;
var widgets = require('../lib/widgets');

var _Base = require('./_Base');

var ShowHide = _Base.extend({
  init: function() {
    var self = this;

    this.classes = {
      open: 'is-open'
    };

    this.$content = this.$el.find('[data-sh-content]').eq(0);
    this.$toggle = this.$el.find('[data-sh-toggle]').eq(0);
    this.isOpen = this.$el.hasClass(this.classes.open);

    this.$toggle.attr('tabindex','0');

    if (!this.isOpen) this.close();

    this.$toggle.on('click', function(event) {
      event.preventDefault();
      self.toggle();
    });
  },
  onWidgetsReady: function() {
    this.iconToggle = widgets.getDescendants(this.$el, 'IconToggle')[0];

    if (this.isOpen && this.iconToggle) {
      this.iconToggle.toggle();
    }
  },
  toggle: function() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  },
  open: function(animate) {
    var self = this;
    this.isOpening = true;
    this.$content.velocity('slideDown', {
      duration: typeof animate === 'undefined' || animate ? 300 : 0,
      complete: function() {
        self.$el.addClass(self.classes.open);
        self.isOpen = true;
        self.isOpening = false;
      }
    });
  },
  close: function() {
    var self = this;
    this.isClosing = true;
    this.$content.velocity('slideUp', {
      complete: function() {
        self.$el.removeClass(self.classes.open);
        self.isOpen = false;
        self.isClosing = false;
      }
    });
  }
});

module.exports = ShowHide;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/ShowHide.js
// module id = 45
// module chunks = 0 1